// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__UeTfi","link":"Logo_link__y5IMb","linkUnclickable":"Logo_linkUnclickable__BF4x6","text":"Logo_text__+z8q1","image":"Logo_image__rKTw5"};